import { useApiHealth } from "../hooks/useHealth";

export function HealthBanner() {
  const status = useApiHealth();

  const label =
    status === "online" ? "API reachable" : status === "offline" ? "API unreachable" : "Checking API…";

  return (
    <div
      data-testid="health-banner"
      role="status"
      style={{
        padding: "0.5rem 1rem",
        fontSize: "0.85rem",
        background: status === "offline" ? "#fdecea" : status === "online" ? "#e8f5e9" : "#fff8e1",
        color: "#333",
      }}
    >
      {label}
    </div>
  );
}
